import * as actionTypes from "../actionTypes/Index";
import { paiyaGiftInitialState } from "./InitialState";
import { IActionType, IPaiyaGift } from "../../interfaces/Index";

const initialState = { ...paiyaGiftInitialState }

export default function paiyaGiftReducer(
    state = initialState,
    action: IActionType
) {
    switch (action.type) {

        /*******  CREATE PAIYA GIFT ******/
        case actionTypes.CREATE_PAIYA_GIFT_INIT: {
            return Object.assign({}, state, {
                isLoading: true,
                isError: false,
                error: null,
                isPaiyaGiftCreated: false,
            });
        }
        case actionTypes.CREATE_PAIYA_GIFT_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                isError: false,
                error: null,
                isPaiyaGiftCreated: true,
            });
        }
        case actionTypes.CREATE_PAIYA_GIFT_FAIL: {
            return Object.assign({}, state, {
                isLoading: false,
                isError: true,
                error: action.error,
                isPaiyaGiftCreated: false,
                paiyaGifts: [],
            });
        }


        /*******  GET PAIYA GIFTS LIST ******/
        case actionTypes.FETCH_PAIYA_GIFT_INIT: {
            return Object.assign({}, state, {
                isLoading: true,
                isError: false,
                error: null,
                isPaiyaGiftsFetched: false,
                paiyaGifts: [],
            });
        }
        case actionTypes.FETCH_PAIYA_GIFT_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false,
                isError: false,
                error: null,
                isPaiyaGiftsFetched: true,
                paiyaGifts: (action.payload as Array<IPaiyaGift>).slice(),
            });
        }
        case actionTypes.FETCH_PAIYA_GIFT_FAIL: {
            return Object.assign({}, state, {
                isLoading: false,
                isError: true,
                error: action.error,
                isPaiyaGiftsFetched: false,
                paiyaGifts: [],
            });
        }

        /********* CLEAR PAIYA GIFT DETAILS ********/
        case actionTypes.CLEAR_PAIYA_GIFT_DETAILS: {
            return Object.assign({}, state, {
                isLoading: false,
                isError: false,
                error: null,
                isPaiyaGiftCreated: false,
                paiyaGifts: [],
            })
        }

        default:
            return state;

    }
}